import React from 'react';
import { FaPlay } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@theme/useTheme';
import { trackGtmButtonClick } from '@/analytics/gtm';

interface StartAssessmentCardProps {
  title: string;
  subTitle: string;
  buttonText: string;
}

const StartAssessmentCard: React.FC<StartAssessmentCardProps> = ({
  title,
  subTitle,
  buttonText
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  const handleStartAssessment = () => {
    const isRetake = /retake/i.test(buttonText);
    trackGtmButtonClick({
      button_id: isRetake ? 'home_card_retake_assessment' : 'home_card_start_assessment',
      section: 'page_home',
      label: buttonText,
      destination: '/assessment',
    });
    navigate('/assessment');
  };

  return (
    <div
      className="mt-20 rounded-xl p-8 sm:p-10 lg:p-12 border"
      style={{
        backgroundColor: colors.input,
        borderColor: colors.border
      }}
    >
      <div className="text-center mb-8">
        <h3
          className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-4 sm:mb-6"
          style={{ color: colors.heading }}
        >
          {title}
        </h3>
        <p
          className="text-base sm:text-lg lg:text-xl leading-relaxed max-w-2xl mx-auto"
          style={{ color: colors.text }}
        >
          {subTitle}
        </p>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleStartAssessment}
          className="group flex items-center justify-center px-8 py-4 rounded-full font-semibold text-white transition-all duration-300 hover:shadow-xl hover:scale-105"
          style={{
            backgroundColor: colors.primaryButton
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = colors.primary;
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = colors.primaryButton;
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <FaPlay className="mr-3 transition-transform duration-200 group-hover:translate-x-0.5" size={18} />
          <span className="text-lg">{buttonText}</span>
        </button>
      </div>
    </div>
  );
};

export default StartAssessmentCard;
